import React from 'react';
import { NavLink, Link } from 'react-router-dom';
import Section from './Section.jsx';
import { connect } from 'react-redux';
import SimpleAlert from './SimpleAlert.jsx';

class Projects extends React.Component {
  constructor() {
    super();
    this.state = {
      mobileModal: false,
    }
    this.clickedLink = this.clickedLink.bind(this)
  }
  clickedLink(e) {
    let mobileFriendly = e.target.getAttribute('data-mobile');
    if (mobileFriendly == "false" && this.props.isMobile) {
      e.preventDefault();
      this.showModal();
    }
  }
  showModal() {
    this.setState({mobileModal: true});
  }
  closeModal() {
    this.setState({mobileModal: false});
  }
  render() {
    let that = this;
    let projects = [
      {
        name: "pClickJS",
        link: "/interviewsimulator",
        external: false,
        description: "pClickJS is a JavaScript framework for making 80s/90s style point and click adventures. You can see an example of it in the 'Gorah Interview Simulator' by following the red link or navigating to that page. Not intended for mobile usage.",
			},
			{
        name: "DeathPenalty",
        link: "https://gitlab.com/noes/eval2",
        mobile: true,
        onClick: (e) => that.clickedLink(e),
        description: "This project allows users to execute JavaScript code without using 'eval' or 'new Function(...)', as both are being disallowed in Extension Manifest V3. The name is Death Penalty because I like dramatic naming and the code is being executed which is like giving it the death penalty.",
			},
			{
        name: "Gorah Art Doodles",
        link: "https://doodle.gorah.site",
        mobile: true,
        onClick: (e) => that.clickedLink(e),
        description: "This is a simple image gallery I made specifcally for low-effort art (doodles). Created with React and a PHP backend.",
      }, 
      {
        name: "Web Genie",
        link: "https://gitlab.com/noes/webgenie",
        mobile: true,
        onClick: (e) => that.clickedLink(e),
        description: "Web Genie is a chrome extension with an open functionality that allows you to choose its behaviour by writing code to execute in the content scripts and background script.",
      },
      {
        name: "Midi Editor",
        link: "http://midi.gorah.site",
        onClick: (e) => that.clickedLink(e),
        description: "An app that lets you sequence music and configure synthesizers. Made with React and Redux.",
      },
      {
        name: "YouPaint",
        link: "http://gorah.site/public/youpaint.mp4",
        onClick: (e) => that.clickedLink(e),
        description: "YouPaint is a Chrome extension used to animate and draw overtop of the internet. It is currently in development but you can find a demo video by clicking the link.",
			},
			{
        name: "Flesh Canvas",
        link: "http://fleshcanvas.gorah.site",
        mobile: true,
        onClick: (e) => that.clickedLink(e),
        description: "Flesh Canvas is a mobile-friendly web app that lets you carve drawings on virtual flesh.",
			},
			{
        name: "Electric Fence",
        link: "http://electric-fence.gorah.site",
        mobile: true,
        onClick: (e) => that.clickedLink(e),
        description: "Electric Fence is a simple but challenging game about avoiding a fence.",
      },
      {
        name: "Font Transformer",
        link: "http://gorah.site/font-transformer/index.html",
        onClick: (e) => that.clickedLink(e),
        description: "Font Transformer is a simple tool for converting system fonts and Google Fonts into bitmap or sprite fonts. Made for my own usage.",
      }
    ]
    return (
      <Section>
        <h1>PROJECTS</h1>
        <div className="pBox">
          <p>Here are some works in progress:</p>
          {
            projects.map((proj) => {
              return (
                <Project {...proj}/>
              )
            })
          }
        </div>
        <div className="colorBox"></div>
        {
          this.state.mobileModal &&
          <SimpleAlert mainText="Sorry!" subText="Not on mobile." onClose={() => this.closeModal()}/>
        }
      </Section>
    )
  }
}

const mapStateToProps = (state, newProps) => {
  return {
    isMobile: state.environment.isMobile
  }
}

export default connect(mapStateToProps)(Projects);

let Project = ({name, link, description, mobile = false, external = true, onClick = () => {}}) => {
  return (
    <div className="project">
      {
        !external &&
        <Link data-mobile={`${mobile}`} onClick={onClick} to={link}>{name}</Link>
      }
      {
        external &&
        <a data-mobile={`${mobile}`} onClick={onClick} href={link}>{name}</a>
      }
      <p className="description">
        {description}
      </p>
    </div>
  )
}
